export default [
  {
    icon: 'mdi-eye',
    title: 'Lihat Nilai',
    event: 'onViewNilai',
    akses: 'psp-pelatihan-imbas-nilai.index',
  },
  {
    icon: 'mdi-close',
    title: 'Hapus Kelas',
    event: 'onDelete',
    akses: 'psp-pelatihan-imbas-kelas.delete',
  },
];
